import StorageService from '../interfaces';

const mutations = {
    [StorageService.User.setInfo](state, userInfo) {
        state.userInfo = userInfo;
    },
    [StorageService.User.setToken](state, userToken) {
        state.userToken = userToken;
    },
    [StorageService.User.saveAccount](state, account) {
        state.loginInfo = account;
    },
    [StorageService.Device.set](state, device) {
        state.device = device;
    },
    [StorageService.TabBar.setTabBar](state, tabBar) {
        state.tabBar = tabBar;
    },
    [StorageService.AlivePage.setAlivePage](state, alivePage) {
        state.alivePage = alivePage;
    },
    [StorageService.TabBar.setInnerTabBar](state, innerTabBar) {
        state.innerTabBar = innerTabBar;
    },
    [StorageService.TabBar.setInnerTabBar](state, innerTabBar) {
        state.innerTabBar = innerTabBar;
    },
    [StorageService.perm.setBtnPerm](state, btnPerm) {
        state.btnPerm = btnPerm;
    },
    [StorageService.Reload.chnRateList](state, reload) {
        state.reloadChnRateList = reload;
    },
    [StorageService.Reload.appAreaList](state, reload) {
        state.reloadAppAreaList = reload;
    },
    [StorageService.Reload.tatNameList](state, reload) {
        state.reloadTatNameList = reload;
    },
    [StorageService.Reload.page](state, reload) {
        state.reloadPage = reload;
    },
    [StorageService.Page.tatName](state, tatSimpleNames) {
        state.tatSimpleNames = tatSimpleNames;
    },
    [StorageService.Page.currentOrgDetail](state, currentOrgDetail) {
        state.currentOrgDetail = currentOrgDetail;
    },
    [StorageService.Reload.isLoading](state, flag) {
        state.isLoading = flag;
    },
    [StorageService.Reload.basicInfoFlag](state, flag) {
        state.basicInfoFlag = flag;
    },
    resetState(state) {
        state.userInfo = null;
        state.userToken = null;
        state.loginInfo = null;
        state.device = null;
        state.tabBar = null;
        state.alivePage = null;
        state.innerTabBar = null;
        state.btnPerm = null;
        state.reloadChnRateList = false;
        state.reloadAppAreaList = false;
        state.reloadTatNameList = false;
        state.reloadPage = false;
        state.tatSimpleNames = null;
        state.currentOrgDetail = null;
        state.isLoading = false;
        state.basicInfoFlag = false;
        state.userId = null;
    }
};

export default mutations;



// WEBPACK FOOTER //
// ./src/store/dao/mutations.js